import { Navigate, useParams } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { LocalizedLink } from "@/components/LocalizedLink";
import { useI18n } from "@/i18n";
import { collection2026, c26Lang } from "@/data/collection2026";

const copy = {
  en: { title: "REM7 Collection 2027", note: "Arriving soon", view: "View details →",
    desc: "Discover the REM7 Collection 2027: four new smart toilets from Aureum VII Trading, arriving soon in Spain." },
  es: { title: "REM7 Collection 2027", note: "Próximamente", view: "Ver detalles →",
    desc: "Descubra la Colección REM7 2027: cuatro nuevos inodoros inteligentes de Aureum VII Trading, muy pronto en España." },
};

export default function Collection2026Index() {
  const { language } = useI18n();
  const lang = c26Lang(language);
  const t = copy[lang];
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Literal title so scripts/prerender-head.ts emits the same <title>/og:title
          the runtime renders; verbatim in every language per owner instruction. */}
      <SEO title="REM7 Collection 2027" description={t.desc} url="/collection-2027" />
      <Navigation />
      <main>
        <section className="bg-primary pt-32 pb-14 text-primary-foreground sm:pt-40">
          <div className="container mx-auto max-w-5xl px-4 text-center sm:px-6">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-accent">{t.note}</p>
            <h1 className="font-playfair text-4xl leading-tight sm:text-6xl">{t.title}</h1>
          </div>
        </section>
        <section className="container mx-auto px-4 py-12 sm:px-6 sm:py-16">
          <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {collection2026.map((p) => (
              <li key={p.slug}>
                <LocalizedLink to={`/collection-2027/${p.slug}`} className="group block overflow-hidden rounded-lg border border-border/40 bg-card focus:outline-none focus:ring-2 focus:ring-accent">
                  <div className="aspect-[4/5] overflow-hidden bg-muted">
                    <img src={p.images[0]} alt={`${p.name} — ${p[lang].kicker}`} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-4">
                    <p className="text-[11px] uppercase tracking-widest text-accent">{p[lang].kicker}</p>
                    <h2 className="mt-1 font-playfair text-xl text-primary">{p.name}</h2>
                    <span className="mt-2 inline-block text-sm text-muted-foreground group-hover:text-accent">{t.view}</span>
                  </div>
                </LocalizedLink>
              </li>
            ))}
          </ul>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export function NovaRedirect() {
  const { lang = "en" } = useParams();
  return <Navigate to={`/${lang}/collection-2027/m86-monolith`} replace />;
}

// Collection was renamed 2026 -> 2027; keep old links (emails, search) working.
export function LegacyCollection2026Redirect() {
  const { lang = "en", slug } = useParams();
  return <Navigate to={`/${lang}/collection-2027${slug ? `/${slug}` : ""}`} replace />;
}
